import MessagesProvider from './MessagesContext';
import Messages from './Messages';


interface IProps {
    ticketId: string
}

let Index = (props: IProps) => {
    return (
        <MessagesProvider ticketId={props.ticketId}>
            <Messages />
        </MessagesProvider>
    )
}

export default Index;